// Tasman assets (HIDDEN / WIP page)
// Exterior: 5 real photoshoot images (Celeste Films Día 2), one per mosaic slot.
import tasmanExterior1 from "../../../assets/img/models/tasman/exterior/tasman-exterior-1.webp";
import tasmanExterior2 from "../../../assets/img/models/tasman/exterior/tasman-exterior-2.webp";
import tasmanExterior3 from "../../../assets/img/models/tasman/exterior/tasman-exterior-3.webp";
import tasmanExterior4 from "../../../assets/img/models/tasman/exterior/tasman-exterior-4.webp";
import tasmanExterior5 from "../../../assets/img/models/tasman/exterior/tasman-exterior-5.webp";
import tasmanExterior1Mobile from "../../../assets/img/models/tasman/exterior/tasman-exterior-1-mobile.webp";
import tasmanExterior2Mobile from "../../../assets/img/models/tasman/exterior/tasman-exterior-2-mobile.webp";
import tasmanExterior3Mobile from "../../../assets/img/models/tasman/exterior/tasman-exterior-3-mobile.webp";
import tasmanExterior4Mobile from "../../../assets/img/models/tasman/exterior/tasman-exterior-4-mobile.webp";
import tasmanExterior5Mobile from "../../../assets/img/models/tasman/exterior/tasman-exterior-5-mobile.webp";
// Interior / Características: 5 real interior images (mosaic has 5 slots).
import tasmanInterior1 from "../../../assets/img/models/tasman/interior/tasman-interior-1.webp";
import tasmanInterior2 from "../../../assets/img/models/tasman/interior/tasman-interior-2.webp";
import tasmanInterior3 from "../../../assets/img/models/tasman/interior/tasman-interior-3.webp";
import tasmanInterior4 from "../../../assets/img/models/tasman/interior/tasman-interior-4.webp";
import tasmanInterior5 from "../../../assets/img/models/tasman/interior/tasman-interior-5.webp";
import tasmanAtributesMain from "../../../assets/img/models/tasman/atributes/tasman-atributes-main.webp";
// Tasman color swatches
import tasmanColorInterstellarGray from "../../../assets/img/models/tasman/colors/tasman-color-interstellar-gray.webp";
import tasmanColorBlackPearl from "../../../assets/img/models/tasman/colors/tasman-color-aurora-black-pearl.webp";
import tasmanColorSnowWhitePearl from "../../../assets/img/models/tasman/colors/tasman-color-snow-white-pearl.webp";
import tasmanColorSteelGray from "../../../assets/img/models/tasman/colors/tasman-color-steel-gray.webp";
import tasmanColorTanBeige from "../../../assets/img/models/tasman/colors/tasman-color-tan-beige.webp";
import tasmanColorCityscapeGreen from "../../../assets/img/models/tasman/colors/tasman-color-cityscape-green.webp";
import tasmanColorDenimBlue from "../../../assets/img/models/tasman/colors/tasman-color-denim-blue.webp";
// Tasman hero video assets
import tasmanHeroVideoDesktop from "../../../assets/videos/tasman-hero-desktop.mp4";
import tasmanHeroVideoMobile from "../../../assets/videos/tasman-hero-mobile.mp4";
// Carousel (specifications): desktop assets delivered; reused for mobile until
// dedicated mobile crops arrive.
import tasmanCarouselFrontDesktop from "../../../assets/img/models/tasman/carousel/tasman-front-desktop.webp";
import tasmanCarouselSideDesktop from "../../../assets/img/models/tasman/carousel/tasman-side-desktop.webp";
import tasmanCarouselBackDesktop from "../../../assets/img/models/tasman/carousel/tasman-back-desktop.webp";
import tasmanCarouselFrontMobile from "../../../assets/img/models/tasman/carousel/tasman-front-mobile.webp";
import tasmanCarouselSideMobile from "../../../assets/img/models/tasman/carousel/tasman-side-mobile.webp";
import tasmanCarouselBackMobile from "../../../assets/img/models/tasman/carousel/tasman-back-mobile.webp";
// Tasman Ficha Técnica
import tasmanFichas from "../../../assets/fichas/Ficha técnica Tasman.pdf";

export const tasmanImages = {
  carousel: {
    front: {
      desktop: tasmanCarouselFrontDesktop,
      mobile: tasmanCarouselFrontMobile,
    },
    back: {
      desktop: tasmanCarouselBackDesktop,
      mobile: tasmanCarouselBackMobile,
    },
    side: {
      desktop: tasmanCarouselSideDesktop,
      mobile: tasmanCarouselSideMobile,
    },
  },
  exterior: {
    image1: {
      desktop: tasmanExterior1,
      mobile: tasmanExterior1Mobile,
    },
    image2: {
      desktop: tasmanExterior2,
      mobile: tasmanExterior2Mobile,
    },
    image3: {
      desktop: tasmanExterior3,
      mobile: tasmanExterior3Mobile,
    },
    image4: {
      desktop: tasmanExterior4,
      mobile: tasmanExterior4Mobile,
    },
    image5: {
      desktop: tasmanExterior5,
      mobile: tasmanExterior5Mobile,
    },
  },
  interior: {
    image1: {
      desktop: tasmanInterior1,
      mobile: tasmanInterior1,
    },
    image2: {
      desktop: tasmanInterior2,
      mobile: tasmanInterior2,
    },
    image3: {
      desktop: tasmanInterior3,
      mobile: tasmanInterior3,
    },
    image4: {
      desktop: tasmanInterior4,
      mobile: tasmanInterior4,
    },
    image5: {
      desktop: tasmanInterior5,
      mobile: tasmanInterior5,
    },
  },
  colors: {
    interstellarGray: tasmanColorInterstellarGray,
    blackPearl: tasmanColorBlackPearl,
    snowWhitePearl: tasmanColorSnowWhitePearl,
    steelGray: tasmanColorSteelGray,
    tanBeige: tasmanColorTanBeige,
    cityscapeGreen: tasmanColorCityscapeGreen,
    denimBlue: tasmanColorDenimBlue,
  },
  attributes: {
    desktop: tasmanAtributesMain,
    mobile: tasmanAtributesMain,
  },
  heroImage: { desktop: tasmanInterior1, mobile: tasmanInterior1 },
  heroVideo: {
    desktop: tasmanHeroVideoDesktop,
    mobile: tasmanHeroVideoMobile,
  },
  etiqueta: null,
  fichas: tasmanFichas,
};
